import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { SegmentEvents }from '../../constants/SegmentEvents';
import { MapsAddStuffService } from '../../maps-add-stuff.service';
import { Property } from '../../classes/property';

@Component({
  selector: 'app-add-property',
  templateUrl: './add-property.component.html',
  styleUrls: ['./add-property.component.less'],
  encapsulation: ViewEncapsulation.None
})

//TODO refactor code here will break, setContent part
export class AddPropertyComponent implements OnInit {

  addPropertyForm: FormGroup;
  addPropertyStep2Form: FormGroup;
  submitted = false;
  property = new Property();
  addPropertyFlowSubscription: Subscription;
  showAddPropertyStep1: boolean = false;
  showAddPropertyStep2: boolean = false;
  mapClickListener: any;
  zoomListener: any;
  tenants: any[] = [];
  retailerSearchResults: any[] = [];
  showRetailerSearchResults: boolean = false;
  retailerSearchIndex: number;
  enableRetailers: boolean = false;
  editMode: boolean = false;
  currentInstruction: string = '';
  nameMarker: any;
  addPropertyMarkerId: number = 0;
  grabToEditMarker: any;
  isSaving: boolean = false;
  doNotSetDefaultRetailer = false;
  inputChangeListener: Subject<any> = new Subject<any>();
  inputSFChangeListener: Subject<any> = new Subject<any>();
  inputGLAChangeListener: Subject<any> = new Subject<any>();
  focusedSearchItemIndex: number = 0;
  searchPredictions: any = [];
  deleteRetailerInMasterMap: boolean = false;
  isPropertyEditLoading: boolean = false;
  editModeAddedRetailers: any[] = [];

 //Events Subscription
  addPropertySubscription: any;
  editPropertyPolygonSubscription: any;
  editPropertySubscription: any;
  removePropertySubscription: any;
  alterPropertyCapsulePublicSubscription: any;
  hideGrabToEditMarkerSubscription: any;
  addPropertyAfterSignupSubscription: any;
  editPropertyAfterSignupSubscription: any;
  deleteRowMastermapSubscription: any;
  closeAddPropertyFlowSubscription: any;
  checkIfRetailerInPropertySubscription: any;
  retailerFilterStateBeforeAddProperty: boolean = true;

  constructor(public mapsAddStuffService: MapsAddStuffService, public _sanitizer: DomSanitizer,
               public formBuilder: FormBuilder) {
    this.initializeInputListeners()
  }

  ngOnInit() {
    this.initializeSubscriptions();
    this.initializeForms();
  }

  initializeForms() {
    this.addPropertyForm = this.formBuilder.group({
      name: [this.property.name, Validators.compose([Validators.required, Validators.maxLength(59)])],
      grossLeasableArea: [this.property.grossLeasableArea, Validators.compose([Validators.pattern(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/)])],
      description: [this.property.description],
    });

    this.addPropertyStep2Form = this.formBuilder.group({
      tenantSF : this.formBuilder.array([])
    });
  }

  initializeSubscriptions() {
    let w = (<any>window);
    this.addPropertyFlowSubscription = this.mapsAddStuffService.addPropertyFlowActiveStream.subscribe((start)=> {
      if(start) {
        this.beginPropertyFlow();
      }
    });

    this.addPropertySubscription = w.Events.subscribe('addProperty',(data)=> {
      w.Events.publish('toggleRooftopRetailerSelection', 'all');
      this.property.polygon = data.polygonShape;
      this.showGrabToEditMarker();
      this.editMode? this.beginEditFlow(): this.goToAddPropertyStep1();
    });

    this.editPropertyPolygonSubscription = w.Events.subscribe('editPropertyPolygon',(data)=> {
      this.hideGrabToEditMarker(true);
      this.property.polygon = data.polygonShape;
      this.property.position = w.getPolygonCenter(this.property.polygon);
      if(this.editMode) {
        let property = w.apiProperty.getSingleProperty(this.property.id, this.property.sourceId);
        property.setPosition(w.apiProperty.getPropertyPositionAbovePolygon(this.property));
        property.setOriginalPosition(w.apiProperty.getPropertyPositionAbovePolygon(this.property));
      } else if(this.nameMarker) {
        this.nameMarker.setPosition(w.apiProperty.getPropertyPositionAbovePolygon(this.property))
      }
      if(this.showAddPropertyStep2) {
        this.goToAddPropertyStep2(true);
      }
    });

    this.editPropertySubscription = w.Events.subscribe('editProperty',(property)=> {
      w.Events.publish('toggleRooftopRetailerSelection', 'all');
      this.editMode = w.editMode = true;
      w.apiProperty.toggleMarkers();
      if(!property.details) {
        this.mapsAddStuffService.getSinglePropertyDetails(property.id, property.globalId).subscribe((response)=>{
          this.setPropertyData(property, response);
        },
        (error)=>{
          if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
            w.Events.publish('usageLimitErrorFeature', 'save-property');
          }
          w.Events.publish('error', error);
        });
      } else {
        let details = property.details;
        this.setPropertyData(property, details);
      }
    });

    this.removePropertySubscription = w.Events.subscribe('removeProperty',(property)=> {
      this.mapsAddStuffService.deleteProperty(property.id, property.globalId).subscribe((response)=>{
        w.apiProperty.delete(property.id, property.sourceId);
        w.Events.publish('segment', {
          name: SegmentEvents.mapPropertyRemoved,
          data: {
            property_global_id: property.details.globalId,
            property_id:  property.details.id,
            property_name: property.details.name,
            property_city: property.details.city,
            property_state: property.details.state,
            property_organization_name: property.details.organization && property.details.organization.name ? property.details.organization.name : null,
          }
        });
        w.apiPropertyCluster.resetAndFetch();
        w.leaderLines.showLeaderLines();
      },(error)=>{
        if(error.status === 403) {
          if(error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
            w.Events.publish('usageLimitErrorFeature', 'save-property');
          } else if(error.error.showPopup && error.error.message === 'cannot.update.public.property') {
            w.contextualInfoWindow.togglePropertyContactSupportPopup(true);
          }
        }
        !error.error.showPopup && w.Events.publish('error', error);
      });
    });

    this.alterPropertyCapsulePublicSubscription = w.Events.subscribe('alterPropertyCapsulePublic',(data)=>{
      this.setPropertyData(data, data.details, true);
      this.property.applyToCapsuleRecord = data.applyToCapsuleRecord;
      this.property.approvedForPublicView = data.approvedForPublicView;
      this.mapsAddStuffService.updateProperty(this.property).subscribe((response)=> {
        this.editDone(response);
      },(error)=>{
        w.Events.publish('error', error);
      });
    });

    this.hideGrabToEditMarkerSubscription = w.Events.subscribe('hideGrabToEditMarker',()=> {
      this.hideGrabToEditMarker(true);
    });

    this.addPropertyAfterSignupSubscription = w.Events.subscribe('addPropertyAfterSignup', (data)=>{
      if(data) {
        this.mapsAddStuffService.addProperty(data).subscribe((response)=> {
          this.done(response);
        },(error)=>{
          w.Events.publish('error', error);
        });
      }
    });

    this.editPropertyAfterSignupSubscription = w.Events.subscribe('editPropertyAfterSignup', (data)=>{
      if(data) {
        this.mapsAddStuffService.updateProperty(data).subscribe((response)=> {
          for(let tenant of this.tenants) {
            for(let event of tenant.events) {
              (<any>window).google.maps.event.removeListener(event);
            }
            tenant.setMap(null);
          }
          this.editDone(response);
        },(error)=>{
          w.Events.publish('error', error);
        });
      }
    });

    this.deleteRowMastermapSubscription = w.Events.subscribe('deleteRowMastermap', (data)=>{
      if(data) {
        this.deleteRetailerInMasterMap = true;
        this.deleteRow(data.index, data.editPolygon);
      }
    });

    this.closeAddPropertyFlowSubscription = w.Events.subscribe('closeAddPropertyFlow', (value)=>{
      this.cancel();
    });
  }

  initializeInputListeners() {
    this.inputChangeListener
    .debounceTime(500)
    .distinctUntilChanged()
    .subscribe((data)=> {
      this.mapsAddStuffService.getRetailerWithName(data.value).subscribe((res: any) => {
        this.searchPredictions = res;
        this.focusedSearchItemIndex = 0;
        this.retailerSearchResults = res;
        this.retailerSearchIndex = data.index;
        (<any>window).Events.publish('detectChanges');
        data.value.length > 0 && this.adjustScrollTenantScrollBar(true);
        let searchItems = document.getElementsByClassName('tenant-suggestion');
        (this.retailerSearchResults.length > 0) ? this.changeFocusedSearchItemBackgroundColor(searchItems) : '';
      });
    });

    this.inputSFChangeListener
    .debounceTime(500)
    .distinctUntilChanged()
    .subscribe((data)=> {
      let doc = <HTMLInputElement>document.getElementById('tenant-squarefeet-'+data.index+'');
      this.tenants[data.index].squareFeet = doc.value = doc.value.replace(/\s/g,'');
      let formArray = <FormArray>this.addPropertyStep2Form.controls['tenantSF'];
      let formGroup = <FormGroup>formArray.controls[data.index];
      formGroup.controls['tenantSF'].setValue(this.tenants[data.index].squareFeet);
      (<any>window).Events.publish('detectChanges');
    });

    this.inputGLAChangeListener
    .debounceTime(500)
    .subscribe((data)=> {
      let doc = <HTMLInputElement>document.getElementById('property-gla-input');
      this.property.grossLeasableArea = doc.value = doc.value.replace(/\s/g,'');
      this.addPropertyForm.controls['grossLeasableArea'].setValue(this.property.grossLeasableArea);
      (<any>window).Events.publish('detectChanges');
    });
  }

  showGrabToEditMarker() {
    let w = (<any>window);
    let showPropertyGrabToEdit = Cookie.get('marqetmap-' + this.mapsAddStuffService.environmentName + '.showPropertyGrabToEdit');
    if(!showPropertyGrabToEdit && !this.grabToEditMarker) {
      this.grabToEditMarker = new w.RichMarker({
        map: w.map,
        position: w.getSouthMostPointOfPolygon(this.property.polygon),
        content: this.getGrabToEditMarkerContent(),
        shadow: '',
        draggable: false,
      });
    }
  }

  hideGrabToEditMarker(manuallyClosed?) {
    let w = (<any>window);
    if(this.grabToEditMarker) {
      if(manuallyClosed) {
        Cookie.set('marqetmap-' + this.mapsAddStuffService.environmentName + '.showPropertyGrabToEdit', 'true', 2147483647, '/');
      }
      this.grabToEditMarker.setMap(null);
      this.grabToEditMarker = null;
      w.google.maps.event.clearListeners(this.property.polygon, 'drag');
    }
  }

  getGrabToEditMarkerContent() {
    return '<div class="grab-to-edit-container">'+
             'Grab to edit.'+
             '<i id="close-grab-to-edit" class="material-icons" onclick="apiProperty.hideGrabToEditMarker()">close</i>'+
           '</div>';
  }

  addTenantForm() {
    let formArray = <FormArray>this.addPropertyStep2Form.controls['tenantSF'];
    formArray.push(this.formBuilder.group({
      tenantSF: ['', Validators.compose([Validators.pattern(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/)])],
    }));
  }

  removeTenantForm(index) {
    let formArray = <FormArray>this.addPropertyStep2Form.controls['tenantSF'];
    let formGroup = <FormGroup>formArray.controls[index];
    formGroup.disable();
  }

  toggleIsPropertyEditLoading(toggle) {
    this.isPropertyEditLoading = toggle;
    (<any>window).Events.publish('detectChanges');
  }

  setPropertyData(property, details, doNotBeginFlow?) {
    let w = (<any>window);
    this.property.name = details.name;
    this.property.id = details.id;
    this.property.retailerLocations = details.retailerLocations;
    this.property.addressText = details.addressText;
    this.property.grossLeasableArea = details.grossLeasableArea;
    this.property.description = details.description;
    this.property.polygon = property.polygon;
    this.property.position = property.position;
    this.property.globalId = property.globalId;
    this.property.inhibitFork = property.editAsAdmin;
    this.property.ownerProfileId = details.ownerProfileId;
    if(this.property.grossLeasableArea) {
      this.property.grossLeasableArea = w.commafy(this.property.grossLeasableArea);
    }

    (<any>window).Events.publish('detectChanges');
    if(!doNotBeginFlow) {
      this.property.polygon ? this.beginEditFlow(): this.beginPropertyFlow();
    }
  }

  toggleShowRetailerSearchResults(toggle, index, event?) {
    this.showRetailerSearchResults = toggle;
    toggle && this.searchRetailer(event, index);
    if(!toggle && parseInt(index)>=0 && !this.doNotSetDefaultRetailer) {
      this.setRetailerDefaultMarker(index);
    }
    this.doNotSetDefaultRetailer = false;
    (<any>window).Events.publish('detectChanges');
  }

  //Add property

  beginPropertyFlow() {
    let w = (<any>window);
    if (!w.mapData.retailerFilterActive) {
      this.retailerFilterStateBeforeAddProperty = false;
      w.apiRetailer.toggleVisible(true);
    } else {
      this.retailerFilterStateBeforeAddProperty = true;
    }
    
    this.editMode && w.map.setOptions({
      center: this.property.position,
      zoom: 18
    });
    w.drawingManager.setDrawingMode(null);
    w.cancelAddingProperty = false;
    w.contextualInfoWindow.closeAllInfoWindows();
    w.domBody && w.addClass(w.domBody, 'add-property');
    if(w.map.getZoom() >= 18) {
      w.ongoingAddProperty = true;
      w.polygon.drawPropertyPolygon();
      this.currentInstruction = 'Draw property boundary on the map.';
    } else {
      this.currentInstruction = 'Zoom to property location on the map.';
      w.map.setOptions({ draggableCursor:'zoom-in' });
    }
    (<any>window).Events.publish('detectChanges');

    this.mapClickListener = w.google.maps.event.addListener(w.map,'click',(e)=>{
      if(w.map.getZoom() < 18) {
        w.map.setCenter(e.latLng);
        w.map.setZoom(18);
      } 
     
      w.ongoingAddProperty = true;
      if(!this.property.polygon) {
        w.polygon.drawPropertyPolygon();
        w.map.setOptions({ draggableCursor: '' });
        this.currentInstruction = 'Draw property boundary on the map.';
      }
      (<any>window).Events.publish('detectChanges');
    });

    this.zoomListener = w.google.maps.event.addListener(w.map,'zoom_changed',()=>{
      if(w.map.getZoom() < 18) {
        w.map.setZoom(18);
      } else if(!this.property.polygon) {
        w.ongoingAddProperty = true;
        w.polygon.drawPropertyPolygon();
      }
    });
  }

  goToAddPropertyStep1() {
    let w = (<any>window);
    this.editMode && w.apiProperty.movePropertyToPolygonTop(w.apiProperty.getSingleProperty(this.property.id, this.property.sourceId));
    this.showAddPropertyStep1 = true;
    this.showAddPropertyStep2 = false;
    (<any>window).Events.publish('detectChanges');
    setTimeout(()=>{
      this.mapsAddStuffService.focusFirstEmptyElement('form-input');
    },0);
  }

  goToAddPropertyStep2(editPolygon?) {
    let w = (<any>window);
    this.showAddPropertyStep1 = false;
    this.showAddPropertyStep2 = true;
    (<any>window).Events.publish('detectChanges');

    this.mapsAddStuffService.getRetailerData(w.getPolygonGeoJson(this.property.polygon)).subscribe((tenants: any) => {
      for(var i = 0; i < tenants.count; i++) {
        let isRetailerExsisting = this.getExistingRetailerInTenantList(tenants.objects[i]);
        let retailer = w.apiRetailer.getSingleRetailer(tenants.objects[i].retailerId, tenants.objects[i].locationId);
        if(retailer) {
          if(!isRetailerExsisting) {
            retailer.setDraggable(true);
            retailer.featured = false;
            retailer.available = false;
            retailer.squareFeet = null;
            retailer.spaceNumber = null;
            retailer.events = this.addTenantMarkerEvents(retailer);
            retailer.backUp = {
              type: 'retailer',
              retailerId: retailer.retailerId,
              position: retailer.getOriginalPosition(),
              content: retailer.content,
              name: retailer.name
            };
            this.addNewTenantsToList(retailer);
          } else {
            if(this.editMode && editPolygon && this.tenants && this.tenants[isRetailerExsisting.arrayPosition].deleted) {
              this.tenants[isRetailerExsisting.arrayPosition].deleted = false;
              this.addTenantForm();
            }
          }
        }
      };
      if(this.tenants.length === 0 && !this.editMode) {
        for (let i = 0; i < 5; i++) {
          this.addRow();
        }
      }
      this.toggleIsPropertyEditLoading(false);
      (<any>window).Events.publish('detectChanges');
    });
  }

  onSubmitStep1Edit() {
    this.submitted = true;
    if(this.addPropertyForm.valid) {
      this.onSubmitStep2();
    }
    (<any>window).Events.publish('detectChanges');
    return false;
  }

  onSubmitStep1() {
    this.submitted = true;
    if(this.addPropertyForm.valid) {
      (this.editMode)?this.goToEditPropertyStepTwo():this.goToAddPropertyStep2();
    }
    (<any>window).Events.publish('detectChanges');
    return false;
  }

  onSubmitStep2() {

    this.resetRetailerState();

    let w = (<any>window)
    if(this.addPropertyStep2Form.valid || this.addPropertyStep2Form.status === 'DISABLED') {
      this.isSaving = true;
      this.property.retailerLocations = this.constructRetailorLocationsObject();
      if(this.editMode) {
        w.Events.publish('startLoadingWhite');
        this.mapsAddStuffService.updateProperty(this.property).subscribe((response: any)=> {
          this.addRetailersIdsToFilter(response.retailerLocations);
          this.editDone(response);
          w.Events.publish('segment', {
            name: SegmentEvents.mapPropertyEdited,
            data: {
              property_global_id: response.globalId,
              property_id:  response.id,
              property_name: response.name,
              property_city: response.city,
              property_state: response.state,
              property_organization_name: response.organization && response.organization.name ? response.organization.name : null,
            }
          });
          w.Events.publish('endLoadingWhite');
        },
        (error) => {
	        this.isSaving = false;
          w.Events.publish('endLoadingWhite');
          if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
            w.Events.publish('usageLimitErrorFeature', 'edit-property');
            w.Events.publish('updateFeatureExecutionAfterSignUp', {
              featureToExecute: 'edit-property',
              requestObject: this.property
            })
          }
          w.Events.publish('error', error);
        });
      } else {
        w.Events.publish('startLoadingWhite');
        this.mapsAddStuffService.addProperty(this.property).subscribe((response: any)=> {
          this.addRetailersIdsToFilter(response.retailerLocations);
          this.done(response);
          w.Events.publish('segment', {
            name: SegmentEvents.mapPropertyAdded,
            data: {
              property_global_id: response.globalId,
              property_id:  response.id,
              property_name: response.name,
              property_city: response.city,
              property_state: response.state,
              property_organization_name: response.organization && response.organization.name ? response.organization.name : null,
            }
          });
          w.Events.publish('endLoadingWhite');
        },
        (error) => {
	        this.isSaving = false;
          w.Events.publish('endLoadingWhite');
          if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
            w.Events.publish('usageLimitErrorFeature', 'save-property');
            w.Events.publish('updateFeatureExecutionAfterSignUp', {
              featureToExecute: 'save-property',
              requestObject: this.property
            })
          }
          w.Events.publish('error', error);
        });
      }
      (<any>window).Events.publish('detectChanges');
      return false;
    }
  }

  addRetailersIdsToFilter(retailerArray) {
    let retailers: any[] = [];
    if(retailerArray.length > 0) {
      for(let i = 0; i < retailerArray.length; i++) {
        if(this.editMode) {
          let editedRetailer = this.editModeAddedRetailers.find((obj: any) => {
            return obj.retailerId ? obj.retailerId === retailerArray[i].retailerId : obj.name === retailerArray[i].name;
          });
          editedRetailer && retailers.push(retailerArray[i]);
        } else {
          retailers.push(retailerArray[i]);
        }
      }
      (<any>window).toggleRetailerFilter(retailers, true);
    }
  }

  //Edit Property

  beginEditFlow() {
    let w = (<any>window);
    (<any>window).Events.publish('detectChanges');
    w.addClass(w.domBody, 'add-property');
    w.map.setZoom(18);
    if(this.property.polygon) {
      w.apiProperty.getSingleProperty(this.property.id, this.property.sourceId).polygon && this.property.polygon.setEditable(true);
      w.fitPolygonToLeftHandSide(this.property.polygon);
      this.showGrabToEditMarker();
    }
    if(!this.zoomListener) {
      this.zoomListener = w.google.maps.event.addListener(w.map,'zoom_changed',()=>{
        if(w.map.getZoom() < 18) {
          w.map.setZoom(18);
        }
      });
    }
    this.goToEditPropertyStepTwo();
  }

  goToEditPropertyStepTwo() {
    let w = (<any>window);
    this.showAddPropertyStep1 = false;
    this.showAddPropertyStep2 = false;
    this.toggleIsPropertyEditLoading(true);
    (<any>window).Events.publish('detectChanges');
    this.tenants = [];
    for(let i=0; i < this.property.retailerLocations.length; i++) {
      if(this.property.retailerLocations[i].available) {
        let availableMarker = w.apiProperty.getSinglePropertyAvailableSpace(this.property.id, this.property.retailerLocations[i].locationId);
        if(availableMarker) {
          availableMarker.deleted = false;
          availableMarker.setDraggable(true);
          availableMarker.backUp = {
            type: 'available-space',
            spaceNumber: availableMarker.spaceNumber,
            position: availableMarker.getOriginalPosition(),
            content: availableMarker.content
          };
          availableMarker.events = this.addTenantMarkerEvents(availableMarker);
          this.addNewTenantsToList(availableMarker);
        }
      } else if(this.property.retailerLocations[i].retailerId && this.property.retailerLocations[i].locationId) {
        let retailer = w.apiRetailer.getSingleRetailer(this.property.retailerLocations[i].retailerId, this.property.retailerLocations[i].locationId);
        if(retailer) {
          retailer.setDraggable(true);
          retailer.backUp = {
            type: 'retailer',
            retailerId: this.property.retailerLocations[i].retailerId,
            position: new w.google.maps.LatLng(this.property.retailerLocations[i].geom.coordinates[1],this.property.retailerLocations[i].geom.coordinates[0]),
            content: retailer.content,
            name: retailer.name
          };
          retailer.featured = this.property.retailerLocations[i].featured;
          retailer.available = this.property.retailerLocations[i].available;
          retailer.squareFeet = this.property.retailerLocations[i].squareFeet;
          retailer.spaceNumber = this.property.retailerLocations[i].spaceNumber;
          retailer.events = this.addTenantMarkerEvents(retailer);
          this.addNewTenantsToList(retailer);
        }
      } else {
        let marker = new w.RichMarker({
          position: new w.google.maps.LatLng(this.property.retailerLocations[i].geom.coordinates[1],this.property.retailerLocations[i].geom.coordinates[0]),
          originalPosition: new w.google.maps.LatLng(this.property.retailerLocations[i].geom.coordinates[1],this.property.retailerLocations[i].geom.coordinates[0]),
          content: '',
          visible: w.onRoofTop(),
          draggable: true,
          featured: this.property.retailerLocations[i].featured,
          available: this.property.retailerLocations[i].available,
          squareFeet: this.property.retailerLocations[i].squareFeet,
          spaceNumber: this.property.retailerLocations[i].spaceNumber,
          locationId: this.property.retailerLocations[i].locationId,
          map: w.map,
          shadow: '',
          type: 'add-property-marker',
          id: this.addPropertyMarkerId++,
        });
        w.apiProperty.unsavedPropertyMarkers.push(marker);
        marker.events = this.addTenantMarkerEvents(marker);
        this.addNewTenantsToList(marker);
      }
    }
    (<any>window).Events.publish('detectChanges');
    this.checkIfRetailerInPropertySubscription = w.Events.subscribe('checkIfRetailerInProperty',(retailer)=>{
      let newRetailer = this.property.retailerLocations.find((obj)=>{
        return obj.retailerId === retailer.retailerId && obj.locationId === retailer.locationId;
      }),
      existingTenant = this.getExistingRetailerInTenantList(retailer);
      if(!existingTenant) {
        if(newRetailer) {
          retailer.setDraggable(true);
          retailer.backUp = {
            type: 'retailer',
            retailerId: newRetailer.retailerId,
            position: retailer.getOriginalPosition(),
            content: retailer.content,
            name: retailer.name
          };
          retailer.featured = newRetailer.featured;
          retailer.available = newRetailer.available;
          retailer.squareFeet = newRetailer.squareFeet;
          retailer.spaceNumber = newRetailer.spaceNumber;
          retailer.events = this.addTenantMarkerEvents(retailer);
          this.addNewTenantsToList(retailer);
        } else if(this.property.polygon && w.google.maps.geometry.poly.containsLocation(retailer.getOriginalPosition(), this.property.polygon)) {
          retailer.setDraggable(true);
          retailer.backUp = {
            type: 'retailer',
            retailerId: retailer.retailerId,
            position: retailer.getOriginalPosition(),
            content: retailer.content,
            name: retailer.name
          };
          retailer.events = this.addTenantMarkerEvents(retailer);
          this.addNewTenantsToList(retailer);
        }
      }
      (<any>window).Events.publish('detectChanges');
    });
    (<any>window).Events.publish('detectChanges');
    this.goToAddPropertyStep2(true);
    w.leaderLines.showLeaderLines();
  }

  resetRetailerState() {
    let w = (<any>window);
    if(!this.retailerFilterStateBeforeAddProperty) {
      w.apiRetailer.toggleVisible(false);
    } else {
      this.retailerFilterStateBeforeAddProperty = true;
    }
  }

  cancel() {
    let w = (<any>window);
    if(w.map) {
      this.resetRetailerState();
      this.resetMarkersOnCancel();
      w.ongoingAddProperty = w.cancelAddingProperty = (this.property.polygon)? false : true;
      w.drawingManager.setDrawingMode(null);
      w.map.setOptions({ draggableCursor: '' });
      !this.editMode && this.property.polygon && this.property.polygon.setMap(null);
      if(this.editMode) {
        let property = w.apiProperty.getSingleProperty(this.property.id, this.property.sourceId);
        !property.polygon && this.property.polygon && this.property.polygon.setMap(null);
        if(w.apiProperty.markers[property.index].polygon) {
          w.apiProperty.markers[property.index].polygon.setEditable(false);
          w.apiProperty.markers[property.index].polygon.setPath(w.apiProperty.markers[property.index].polygon.backUpPath);
          w.mapListeners.addPropertyPolygonListener(w.apiProperty.markers[property.index].polygon);
        }
        w.apiProperty.movePolygonToCenterOfPolygon(w.apiProperty.markers[property.index]);
        //Revert to old property name
        if(document.getElementById('property-name-'+property.id)) {
          document.getElementById('property-name-'+property.id).innerHTML = this.encodePropertyName(property.name);
        }
      }
      this.clearNameMarker();
      this.removeAllTenants();
      this.closeAddPropertyFlow();
    }
  }

  resetMarkersOnCancel() {
    let w = (<any>window);
    for(let tenant of this.tenants) {
      if(tenant.backUp) {
        switch(tenant.backUp.type) {
          case 'retailer':
            tenant.retailerId = tenant.backUp.retailerId;
            tenant.name = tenant.backUp.name;
            delete tenant.deleted;
            tenant.setPosition(tenant.backUp.position);
            tenant.setOriginalPosition(tenant.backUp.position);
            tenant.setContent(tenant.backUp.content);
            tenant.addClass('on-transition');
            !tenant.getMap() && tenant.setMap(w.map);
            w.apiRetailer.checkIfRetailerIsHidden(tenant);
            break;
          case 'available-space':
            tenant.spaceNumber = tenant.backUp.spaceNumber;
            tenant.available = true;
            tenant.name = '';
            tenant.setContent(w.apiProperty.getAvailableSpaceContent(tenant));
            tenant.setPosition(tenant.backUp.position);
            tenant.setOriginalPosition(tenant.backUp.position);
            !tenant.getMap() && tenant.setMap(w.map);
            w.apiProperty.isAvailableSpaceHidden(tenant);
            break;
        }
      }
    }
  }

  done(response) {
    let w = (<any>window);
    this.isSaving = false;
    w.Events.publish('detectChanges');
    w.Events.publish('trackPropertyIds', response.id);
    this.property.polygon && this.property.polygon.setMap(null);
    w.ongoingAddProperty = false;
    w.cancelAddingProperty = false;
    this.clearNameMarker();
    this.deleteAllPropertyRetailers();
    w.apiProperty.addNewProperty(response, {
      addToTourbook: w.isApplicationTourbooks()
    });
    this.closeAddPropertyFlow();
    w.apiPropertyCluster.resetAndFetch();
  }

  editDone(response) {
    let w = (<any>window);
    this.isSaving = false;
    w.Events.publish('detectChanges');
    w.Events.publish('trackPropertyIds', response.id);
    w.apiProperty.delete(this.property.id, this.property.sourceId);
    this.property.polygon && this.property.polygon.setMap(null);
    this.deleteAllPropertyRetailers();
    w.apiProperty.addNewProperty(response);
    w.ongoingAddProperty = false;
    w.cancelAddingProperty = false;
    w.mapData.currentZoomLevel >= w.ZOOM_LEVELS.property ? w.apiPropertyCluster.resetAll() : w.apiPropertyCluster.resetAndFetch();
    this.editModeAddedRetailers = [];
    this.closeAddPropertyFlow();
    w.apiPropertyCluster.resetAndFetch();
  }

  closeAddPropertyFlow() {
    let w = (<any>window);
    this.submitted = false;
    this.hideGrabToEditMarker();
    this.property = new Property();
    w.removeClass(w.domBody, 'add-property');
    w.editMode = this.editMode = this.showAddPropertyStep1 = this.showAddPropertyStep2 = false;
    w.apiProperty.toggleMarkers();
    w.google.maps.event.removeListener(this.mapClickListener);
    w.google.maps.event.removeListener(this.zoomListener);
    w.apiProperty.unsavedPropertyMarkers = [];
    this.mapClickListener = this.zoomListener = null;
    w.leaderLines.showLeaderLines();
    this.removeAllTenants();
    this.addPropertyStep2Form = this.formBuilder.group({
      tenantSF : this.formBuilder.array([])
    });
    w.grabber.destroyListeners();
    this.mapsAddStuffService.addPropertyFlowActiveSource.next(false);
    w.Events.publish('propertyFiltersToggle', true);
    w.Events.publish('detectChanges');
  }

  deleteAllPropertyRetailers() {
    for(let retailer of this.property.retailerLocations) {
      (<any>window).apiRetailer.delete(retailer.retailerId, retailer.locationId);
    }
  }

  removeAllTenants() {
    let w = (<any>window);
    for(let tenant of this.tenants) {
      for(let event of tenant.events) {
        w.google.maps.event.removeListener(event);
      }
      tenant.setDraggable(false);
      tenant.newSpace && tenant.setMap(null);
    }
    this.tenants = [];
  }

  addRow() {
    let w = (<any>window),
        position = w.getRandomPointInPolygon(this.property.polygon);
    let marker = new w.RichMarker({
      position: position,
      originalPosition: position,
      map: w.map,
      name: '',
      draggable: true,
      featured: false,
      available: false,
      squareFeet: null,
      spaceNumber: '',
      shadow: '',
      type: 'add-property-marker',
      id: this.addPropertyMarkerId++,
      content: '',
      newSpace: true,
      avoidImageLoadListener: true //Breaks leaders line after performance upgrade
    });
    w.apiProperty.unsavedPropertyMarkers.push(marker);
    marker.events = this.addTenantMarkerEvents(marker);
    this.addNewTenantsToList(marker);
    this.adjustScrollTenantScrollBar(false);
  }

  addNewTenantsToList(tenant) {
    tenant.key = this.tenants.length;
    this.tenants.push(tenant);
    this.addTenantForm();
    (<any>window).Events.publish('detectChanges');
  }

  getExistingRetailerInTenantList(tenant) {
    return this.tenants.find((obj, index)=>{
      obj.arrayPosition = index;
      return obj.retailerId === tenant.retailerId && obj.locationId === tenant.locationId;
    });
  }

  checkIfFormGroupIsInvalid(index) {
    let formArray = <FormArray>this.addPropertyStep2Form.controls['tenantSF'];
    let formGroup = <FormGroup>formArray.controls[index];
    return formGroup? formGroup.invalid : false;                                  
  }

  deleteRow(index, editPolygon?) {
    let w = (<any>window);
    if(this.editMode && !this.tenants[index].newSpace && !this.deleteRetailerInMasterMap && w.mmap.isOrganizationEditAdmin()) {
      let propertyData = {
        isPropertySpace: true,
        isProperty: false,
        spaceData: {
          spaceNumber: this.tenants[index].spaceNumber ? this.tenants[index].spaceNumber : '',
          index: index,
          editPolygon: editPolygon ? editPolygon : '',
        }
      };
      w.Events.publish('confirmDeleteInMasterMap', propertyData);
    } else {
      if(this.editMode) {
        let retailer = w.apiRetailer.getSingleRetailer(this.tenants[index].retailerId, this.tenants[index].locationId);
        if(retailer) {
          if(!editPolygon) {
            this.tenants[index].setMap(null);
          } else {
            for(let event of this.tenants[index].events) {
              w.google.maps.event.removeListener(event);
            }
            retailer.setDraggable(false);
          }
        } else {
          this.tenants[index].setMap(null);
        }
        if(this.tenants[index].newSpace) {
          this.tenants.splice(index, 1);
        } else {
          this.tenants[index].deleted = true;
        }
        (<any>window).Events.publish('detectChanges');
      } else {
        let retailer = w.apiRetailer.getSingleRetailer(this.tenants[index].retailerId, this.tenants[index].locationId);
        if(retailer) {
          if(!editPolygon) {
            this.tenants[index].setMap(null);
          } else {
            for(let event of this.tenants[index].events) {
              w.google.maps.event.removeListener(event);
            }
            retailer.setDraggable(false);
          }
        } else {
          this.tenants[index].setMap(null);
        }
        this.tenants.splice(index, 1);
        (<any>window).Events.publish('detectChanges');
      }
      this.removeTenantForm(index);
      w.leaderLines.showLeaderLines();
      this.deleteRetailerInMasterMap = false;
      (<any>window).Events.publish('detectChanges');
    }
  }

  addTenantMarkerEvents(marker) {
    let w = (<any>window);
    let tenantMarkerEvents = [];
    tenantMarkerEvents.push(w.google.maps.event.addListener(marker,'dragstart',(e)=>{
      w.leaderLines.showLeaderLines();
    }));
    tenantMarkerEvents.push(w.google.maps.event.addListener(marker,'dragend',(e)=>{
      if(!w.google.maps.geometry.poly.containsLocation(marker.getPosition(), this.property.polygon)) {
        marker.setPosition(marker.getOriginalPosition());
      }
      marker.originalPosition = marker.getPosition();
      if(marker.retailerId && marker.locationId) {
        let retailer = w.apiRetailer.getSingleRetailer(marker.retailerId, marker.locationId);
        if(retailer) {
          retailer.originalPosition = marker.getPosition();
        }
      }
      w.leaderLines.showLeaderLines();
      (<any>window).Events.publish('detectChanges');
    }));

    return tenantMarkerEvents;
  }

  backToStep1() {
    setTimeout(()=>{
      this.mapsAddStuffService.focusFirstEmptyElement('form-input');
    },0);
    this.showAddPropertyStep1 = true;
    this.showAddPropertyStep2 = false;
    (<any>window).Events.publish('detectChanges');
  }

  backToStep2() {
    this.goToAddPropertyStep2(true);
  }

  getSelectedFeaturedCount() {
    return this.tenants.filter((obj)=>{
      return obj.featured === true && !obj.deleted;
    }).length;
  }

  getActiveTenantsCount() {
    return this.tenants.filter((obj)=>{
      return !obj.deleted;
    }).length;
  }

  toggleAvailable(event:any, index) {
    let w = (<any>window);
    this.tenants[index].available = event.target.checked;
    if(this.tenants[index].available) {
      this.tenants[index].name = '';
      this.tenants[index].setContent(w.apiProperty.getAvailableSpaceContent(this.tenants[index]));
      this.tenants[index].retailerId = null;
      this.tenants[index].featured = false;
    } else {
      this.tenants[index].setContent('<div></div>');
    }
    w.leaderLines.showLeaderLines();
    (<any>window).Events.publish('detectChanges');
  }

  searchRetailer(event: any, index) {
    let w = (<any>window);
    this.tenants[index].retailerId = null;
    document.getElementById('retailer-search-results').style.top = document.getElementById('tenant-row-id-'+ index).offsetTop + 40 + 'px';
    document.getElementById('retailer-search-results').style.width =  document.getElementById('retailer-input-'+ index).offsetWidth + 'px';
    document.getElementById('retailer-search-results').style.left =  document.getElementById('retailer-input-'+ index).offsetLeft + 'px';
    this.inputChangeListener.next({value: event.target.value, index: index});
    this.tenants[index].available = this.tenants[index].name !== ''? false: this.tenants[index].available;
    (<any>window).Events.publish('detectChanges');
  }

  adjustScrollTenantScrollBar(isRetailerDropdownPresent) {
    let tenantDiv: any = document.getElementById('tenant-scroll').children[0],
        retailerDropdownHeightFromTop = document.getElementById('retailer-search-results').offsetTop + 112,
        visibletenantDivHeight = tenantDiv.offsetHeight + tenantDiv.scrollTop;
    if(isRetailerDropdownPresent) {
      if(retailerDropdownHeightFromTop >= visibletenantDivHeight) {
        tenantDiv.scrollTop = (tenantDiv.scrollTop + (retailerDropdownHeightFromTop - visibletenantDivHeight)) + 10;
      }
    } else {
      tenantDiv.scrollTop = tenantDiv.scrollHeight;
    }
  }

  setRetailerDefaultMarker(index) {
    let w = (<any>window);
    if(!this.tenants[index].available) {
      if(/^\s*$/.test(this.tenants[index].name)) {
        this.tenants[index].setContent('');
      } else if(!this.tenants[index].retailerId) {
        this.tenants[index].setContent(w.apiRetailer.getMarkerContent({
          tempRetailerMarker: true,
          name: this.tenants[index].name
        }));
        this.editMode && this.editModeAddedRetailers.push(this.tenants[index]);
      }
    }
  }

  selectRetailerFromSearch(event, retailer) {
    let w = (<any>window);
    this.tenants[this.retailerSearchIndex].retailerId = retailer.retailerId;
    this.tenants[this.retailerSearchIndex].name = retailer.name;
    retailer.ready_ = true;
    this.tenants[this.retailerSearchIndex].setContent(w.apiRetailer.getMarkerContent(retailer));
    this.retailerSearchResults = [];
    this.editMode && this.editModeAddedRetailers.push(this.tenants[this.retailerSearchIndex]);
    (<any>window).Events.publish('detectChanges');
  }

  getTenantInputListeners(event, index:any) {
    let searchInputElement = document.getElementsByClassName('add-property-tenant-input');
    if((<HTMLInputElement>searchInputElement[index]).value.length > 0) {
      let keyCode = event.keyCode;
      //Enter
      if(keyCode === 13) {
        this.doNotSetDefaultRetailer = true;
        this.selectRetailerFromSearch(event, this.searchPredictions[this.focusedSearchItemIndex]);
      }
      // Tab
      if(keyCode === 9 && this.retailerSearchResults.length > 0) {
        this.doNotSetDefaultRetailer = true;
        this.selectRetailerFromSearch(event, this.searchPredictions[this.focusedSearchItemIndex]);
      }
      //Up arrow
      if(keyCode === 38) {
        this.goUpSearchPredictions();
      }
      //Down arrow
      if(keyCode === 40) {
        this.goDownSearchPredictions();
      }
    }
  }

  goUpSearchPredictions() {
    let retailerInfowindow = document.getElementById('retailer-search-results-scroll').children[0];
    if(this.focusedSearchItemIndex === 0) {
      this.focusedSearchItemIndex = this.searchPredictions.length - 1;
      retailerInfowindow.scrollTop = retailerInfowindow.scrollHeight;
    } else {
      this.focusedSearchItemIndex--;
      if(this.focusedSearchItemIndex > 1) {
        retailerInfowindow.scrollTop -= 28;
      }
    }
    let searchItems = document.getElementsByClassName('tenant-suggestion');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  this.searchPredictions.length - 1? 0 : this.focusedSearchItemIndex + 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  goDownSearchPredictions() {
    let retailerInfowindow = document.getElementById('retailer-search-results-scroll').children[0];
    if(this.focusedSearchItemIndex === this.searchPredictions.length - 1) {
      this.focusedSearchItemIndex = 0;
      retailerInfowindow.scrollTop = 0;
    } else {
      this.focusedSearchItemIndex++;
      if(this.focusedSearchItemIndex > 3) {
        retailerInfowindow.scrollTop += 28;
      }
    }
    let searchItems = document.getElementsByClassName('tenant-suggestion');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  0 ? this.searchPredictions.length - 1 : this.focusedSearchItemIndex - 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  changeFocusedSearchItemBackgroundColor(searchItems) {
    (<HTMLElement>searchItems[this.focusedSearchItemIndex]).classList.add('focused');
  }

  toggleFeatured(index) {
    let w = (<any>window);
    if(this.getSelectedFeaturedCount() < 8 || this.tenants[index].featured) {
      if(!this.tenants[index].available) {
        this.tenants[index].featured = !this.tenants[index].featured;
        (<any>window).Events.publish('detectChanges');
      }
    } else {
      w.Events.publish('notificationError', 'Maximum featured tenants limit reached');
    }
  }

  onSpaceNumberChange(index) {
    let w = (<any>window);
    if(this.tenants[index].available) {
      this.tenants[index].setContent(w.apiProperty.getAvailableSpaceContent(this.tenants[index]));
      this.tenants[index].getWidth() < 75 && w.leaderLines.showLeaderLines();
    }
  }

  encodePropertyName(name) {
    return (<any>window).$ESAPI.encoder().encodeForHTML(name);
  }

  changeMarkerName() {
    let w = (<any>window);

    if(this.editMode) {
      if(document.getElementById('property-name-'+this.property.id)) {
        document.getElementById('property-name-'+this.property.id).innerHTML = this.encodePropertyName(this.property.name);
      }
    } else {
      if(this.nameMarker) {
        this.nameMarker.setContent(w.apiProperty.getDefaultMarkerContent(this.property));
      } else {
      this.property.position = w.getPolygonCenter(this.property.polygon);
      this.nameMarker = new w.RichMarker({
          position: w.apiProperty.getPropertyPositionAbovePolygon(this.property),
          map: w.map,
          shadow: '',
          draggable: false,
          content: '<div class="rich-marker">'+ this.encodePropertyName(this.property.name) +'</div>'
        });
      }
    }
  }

  clearNameMarker() {
    this.nameMarker && this.nameMarker.setMap(null);
    this.nameMarker = null;
  }

  constructRetailorLocationsObject() {
    let retailerLocations = [];
    for(let tenant of this.tenants) {
      if(this.isTenantValid(tenant)) {
        retailerLocations.push({
          name: tenant.name,
          retailerId: tenant.retailerId,
          featured: tenant.featured,
          squareFeet: typeof tenant.squareFeet === 'string'?parseInt(tenant.squareFeet.replace(/\,/g,'')):tenant.squareFeet,
          geom: (<any>window).getPointGeoJson(tenant.getOriginalPosition()),
          spaceNumber: tenant.spaceNumber,
          available: tenant.available,
          locationId: tenant.locationId,
          deleted: tenant.deleted
        });
      }
    }
    return retailerLocations;
  }

  isTenantValid(tenant) {
    if(!tenant.name  && !tenant.available) {
      return tenant.locationId && tenant.locationId > 0 ? true : false;
    }
    return true;
  }

  getNonDeletedTenants() {
    return this.tenants.filter((obj, index)=>{
      return !obj.deleted || obj.deleted===false;
    });
  }

  dragPropertyDiv(event) {
    event.preventDefault();
    (<any>window).grabber.initDragDiv(document.getElementById('add-property-drag'), event, {widthBuffer: 100, heightBuffer: 100});
    document.getElementById('add-property-drag').classList.add('grabbing-mode');
  }

  removeSubscriptions() {
    this.addPropertyFlowSubscription && this.addPropertyFlowSubscription.unsubscribe();
    this.addPropertySubscription && this.addPropertySubscription.unsubscribe();
    this.editPropertyPolygonSubscription && this.editPropertyPolygonSubscription.unsubscribe();
    this.editPropertySubscription && this.editPropertySubscription.unsubscribe();
    this.removePropertySubscription && this.removePropertySubscription.unsubscribe();
    this.alterPropertyCapsulePublicSubscription && this.alterPropertyCapsulePublicSubscription.unsubscribe();
    this.hideGrabToEditMarkerSubscription && this.hideGrabToEditMarkerSubscription.unsubscribe();
    this.addPropertyAfterSignupSubscription && this.addPropertyAfterSignupSubscription.unsubscribe();
    this.editPropertyAfterSignupSubscription && this.editPropertyAfterSignupSubscription.unsubscribe();
    this.deleteRowMastermapSubscription && this.deleteRowMastermapSubscription.unsubscribe();
    this.closeAddPropertyFlowSubscription && this.closeAddPropertyFlowSubscription.unsubscribe();
    this.checkIfRetailerInPropertySubscription && this.checkIfRetailerInPropertySubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
    this.cancel();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/components/add-property/add-property.component.ts